module.exports = __webpack_public_path__ + "static/media/corporate-services-img89.a93cc91d.jpg";